import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { usePeopleChartsDataContext } from './usePeopleChartsDataContext';

const usePeopleStratificationPercentage = () => {
    const { chartData } = usePeopleChartsDataContext();

    const categories = chartData.people.map((item) => item.description);

    const subtitles = ['Jovens', 'Adultos', 'Idosos'];

    const totalPerCategory = categories.map((category) => {
        const found = chartData.people
            .filter((counter) => counter.description === category)
            .reduce((acc, curr) => {
                const total =
                    Number(curr.young) +
                    Number(curr.adult) +
                    Number(curr.elder);
                return acc + total;
            }, 0);

        return found ? Number(found) : 0;
    });

    const series = subtitles.map((subtitle) => {
        const data = categories.map((category, index) => {
            if (totalPerCategory[index] === 0) {
                return 0;
            }

            const found = chartData.people.find(
                (counter) => counter.description === category
            );

            let value = 0;

            switch (subtitle) {
                case 'Jovens':
                    value = found.young;
                    break;
                case 'Adultos':
                    value = found.adult;
                    break;
                case 'Idosos':
                    value = found.elder;
                    break;
                default:
                    value = 0;
                    break;
            }

            return found
                ? ((Number(value) / totalPerCategory[index]) * 100).toFixed(2)
                : 0;
        });

        return {
            name: subtitle,
            data
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    borderRadius: 4,
                    borderRadiusApplication: 'end',
                    borderRadiusWhenStacked: 'last'
                }
            },
            yaxis: {
                max: 100
            },
            xaxis: {
                categories: categories || [],
                labels: {
                    formatter: (val) => `${val}%`
                }
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            fill: {
                opacity: 1
            },
            dataLabels: {
                enabled: true,
                formatter: (val) => `${val}%`,
                style: {
                    colors: ['#ffffff'],
                    fontSize: '11px'
                }
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? `${val.toLocaleString('pt-BR')}%` : '')
                }
            },
            colors: defaultColors,
            grid: {
                show: false
            }
        }
    };

    return {
        chartConfig
    };
};

export default usePeopleStratificationPercentage;
